import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/**
 * Lists users.
 * - default behavior keeps existing screens stable: `tipo_responsavel=humanos`
 * - pass `tipoResponsavel: "todos"` (or falsy) to omit the backend filter and include ChatBots (ura=1)
 */
export const useUsers = (page = 1, limit = 100, search = "", tipoResponsavel = "humanos") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["users", page, limit, search, tipoResponsavel],
    () =>
      (() => {
        const base = `/users?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`;
        if (!tipoResponsavel || tipoResponsavel === "todos") return fetchData(base);
        return fetchData(`${base}&tipo_responsavel=${encodeURIComponent(tipoResponsavel)}`);
      })(),
    {
      keepPreviousData: true,
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (res) => ({
        users: res.data || [],
        pagination: res.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (payload) => {
      const method = payload.id ? "PUT" : "POST";
      const endpoint = payload.id ? `/users/${payload.id}` : `/users`;
      return fetchData(endpoint, method, payload);
    },
    { onSuccess: () => queryClient.invalidateQueries("users") }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/users/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("users") }
  );

  return { ...query, updateMutation, deleteMutation };
};
